var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-heading",class:_vm.background},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"text d-inline-block px-3 text-center text-uppercase font-weight-bold"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }